
import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Optionales Label rechts neben dem Switch. */
  label?: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

/**
 * Zentraler Switch (Toggle). button[role=switch] + Div-Knob — funktioniert
 * zuverlässig im Redesign (Light/Dark), unabhängig von `:checked`-Varianten.
 * "An" = Brand (bg-primary), Knob weiß für Kontrast.
 */
export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled, label, ariaLabel, className = "" }) => {
  const toggle = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border p-0 transition-colors ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      } ${checked ? "bg-primary border-primary" : "bg-zinc-300 dark:bg-zinc-600 border-line-strong"}`}
    >
      <span
        // bg-[#fff] (not bg-white): modern EulektroTable dark-mode CSS force-
        // overrides any `.bg-white` to a dark surface, which would hide the knob.
        className={`pointer-events-none absolute top-0.5 h-4 w-4 rounded-full bg-[#fff] shadow transition-transform ${
          checked ? "translate-x-4" : "translate-x-0.5"
        }`}
      />
    </button>
  );

  if (label == null) return <span className={className}>{toggle}</span>;
  return (
    <label className={`inline-flex items-center gap-2 ${disabled ? "" : "cursor-pointer"} ${className}`}>
      {toggle}
      <span className="text-content-2 text-sm">{label}</span>
    </label>
  );
};
